module.exports = __webpack_public_path__ + "img/linkedin__green.90bd1a94.svg";